import React, { useEffect} from 'react'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DashAuthWrapper from './DashAuthWrapper'
import {  fetchAllApptsStart } from '../redux/Appointments/appts.actions';
import "react-datepicker/dist/react-datepicker.css";
import {format} from 'date-fns'

const mapState = ({ apptsData }) => ({
	appts: apptsData.appts,
})

const CustomerApptDetails = props => {
	const { appts } = useSelector(mapState);
	const dispatch = useDispatch();
	const { documentID } = useParams();

	const { apptData } = appts;

	useEffect(() => {
		dispatch(
			fetchAllApptsStart()
		);
		window.scrollTo(0, 0)

		// eslint-disable-next-line
	}, []);


	//only show subscribed customers && filter by custID
	const custAppt = [];
	if(Array.isArray(apptData)){
		for(let i = 0; i < apptData.length; i++){
			if(apptData[i].documentID === `${documentID}`){
				custAppt.push(apptData[i]);
			}
		}
	}



	
	const congfigAuthWrapper = {
		headline: `Appointment Details`
	}
	
	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
			<hr></hr>
			<div className="manageAppts mt-5">
				
				
				<div className="cart">
					<table border="0" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td>
									<table className="convoHeader" border="0" cellPadding="10" cellSpacing="0">
										<tbody >
										<tr >
											<th className="pr-0">
												Service
											</th>
										
											<th className="pl-0 pr-o ml-0">
												Date
											</th>

											<th className="pl-0 pr-o ml-0">
												Vendor
											</th>
											<th>

											</th>
										
										</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td>
									<table className="convoResults" border="0" cellPadding="10" cellSpacing="0">
									<tbody>
									
										{(Array.isArray(custAppt) && custAppt.length > 0) && custAppt.map((appt, index) => {
											const {
												startDate,
												productName,
												vendorsName,
												vendorsPhone
											} = appt;
											
											return (
												<tr key={index}>
												
												<td>
													{productName}
												</td>
												
												<td >
													{format(startDate.toDate(), 'MMM dd, yyyy ')} 
												</td>

												<td>
													{vendorsName}
												</td>

												<td>
												<button className="btn" onClick={() => window.open(`tel:${vendorsPhone}`)}>Call</button>
												</td>


												
												</tr>
											)
										})}

									</tbody>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</DashAuthWrapper>


		
	)
}

export default CustomerApptDetails;